"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.removePercentPrecision = exports.addPercentPrecision = exports.removePrecision = exports.addPrecision = void 0;
var bignumber_js_1 = require("bignumber.js");
var constants_1 = require("./constants");
/**
 * 添加精度
 * @param price
 * @returns
 */
var addPrecision = function (price) {
    return new bignumber_js_1.default(price)
        .times(constants_1.PricePrecision)
        .decimalPlaces(0, bignumber_js_1.default.ROUND_FLOOR)
        .toString();
};
exports.addPrecision = addPrecision;
/**
 * 移除精度
 * @param price
 * @returns
 */
var removePrecision = function (price) {
    return new bignumber_js_1.default(price).div(constants_1.PricePrecision).toString();
};
exports.removePrecision = removePrecision;
var addPercentPrecision = function (price) {
    return new bignumber_js_1.default(price)
        .times(constants_1.PercentagePrecision)
        .decimalPlaces(0, bignumber_js_1.default.ROUND_FLOOR)
        .toString();
};
exports.addPercentPrecision = addPercentPrecision;
/**
 * 移除百分比精度
 * @param price
 * @returns
 */
var removePercentPrecision = function (price) {
    return new bignumber_js_1.default(price).div(constants_1.PercentagePrecision).toString();
};
exports.removePercentPrecision = removePercentPrecision;
